import { useNavigate } from 'react-router-dom';

const areas = [
  { name: 'Richmond Hill', slug: 'richmond-hill' },
  { name: 'Markham', slug: 'markham' },
  { name: 'Stouffville', slug: 'stouffville' },
  { name: 'Aurora', slug: 'aurora' },
  { name: 'Newmarket', slug: 'newmarket' },
  { name: 'Thornhill', slug: 'thornhill' },
  { name: 'Vaughan', slug: null },
  { name: 'Mississauga', slug: null },
  { name: 'North York', slug: null },
  { name: 'Scarborough', slug: 'scarborough' },
  { name: 'Pickering', slug: 'pickering' },
  { name: 'Ajax', slug: 'ajax' },
  { name: 'Whitby', slug: 'whitby' },
  { name: 'Oshawa', slug: 'oshawa' },
];

export default function ServiceAreas() {
  const navigate = useNavigate();

  return (
    <section id="service-areas" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-2 bg-green-50 text-green-700 rounded-full text-sm font-semibold mb-4">
            Where We Work
          </div>
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-6">
            Serving the Greater Toronto Area
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            From the heart of Toronto to the surrounding communities, Mow and Snow delivers
            reliable lawn care and snow removal across the GTA — right to your doorstep.
          </p>
        </div>

        {/* Map + Areas */}
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Map Image */}
          <div className="relative rounded-2xl overflow-hidden h-96 lg:h-[480px]">
            <img
              src="https://public.readdy.ai/ai/img_res/4e523162d93a6e3e0d1797bf2ece4905.jpg"
              alt="Greater Toronto Area service coverage map"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-black/10 to-transparent"></div>
            <div className="absolute bottom-6 left-6 right-6">
              <div className="bg-white/90 backdrop-blur-sm rounded-xl px-5 py-4 flex items-center gap-3">
                <div className="w-10 h-10 flex items-center justify-center bg-green-100 rounded-full">
                  <i className="ri-map-2-line text-green-600 text-xl"></i>
                </div>
                <div>
                  <p className="text-sm font-bold text-gray-900">14 Cities &amp; Neighbourhoods</p>
                  <p className="text-xs text-gray-500">Across the Greater Toronto Area</p>
                </div>
              </div>
            </div>
          </div>

          {/* Areas Grid */}
          <div>
            <p className="text-gray-500 text-sm font-medium uppercase tracking-widest mb-4">
              Our Coverage Areas
            </p>
            <p className="text-xs text-gray-400 mb-4">
              <span className="inline-flex items-center gap-1 text-green-600 font-medium">
                <i className="ri-external-link-line"></i> Highlighted cities
              </span>{' '}
              have dedicated service pages — click to learn more.
            </p>
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
              {areas.map((area, idx) => (
                area.slug ? (
                  <button
                    key={idx}
                    onClick={() => navigate(`/locations/${area.slug}`)}
                    className="group flex items-center gap-3 bg-white border border-green-200 rounded-xl px-4 py-3 hover:bg-green-50 hover:border-green-400 hover:-translate-y-0.5 transition-all duration-200 cursor-pointer text-left"
                  >
                    <div className="w-8 h-8 flex items-center justify-center bg-green-50 rounded-lg group-hover:bg-green-100 transition-colors flex-shrink-0">
                      <i className="ri-map-pin-2-line text-green-600 text-base"></i>
                    </div>
                    <span className="text-sm font-semibold text-gray-800 whitespace-nowrap flex-1">{area.name}</span>
                    <div className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-arrow-right-s-line text-green-500 text-base opacity-0 group-hover:opacity-100 transition-opacity"></i>
                    </div>
                  </button>
                ) : (
                  <div
                    key={idx}
                    className="flex items-center gap-3 bg-white border border-gray-100 rounded-xl px-4 py-3 cursor-default"
                  >
                    <div className="w-8 h-8 flex items-center justify-center bg-gray-50 rounded-lg flex-shrink-0">
                      <i className="ri-map-pin-2-line text-gray-400 text-base"></i>
                    </div>
                    <span className="text-sm font-semibold text-gray-600 whitespace-nowrap">{area.name}</span>
                  </div>
                )
              ))}
            </div>

            {/* CTA */}
            <div className="mt-8 p-5 bg-green-600 rounded-2xl text-white flex flex-col sm:flex-row items-start sm:items-center gap-4">
              <div className="w-12 h-12 flex items-center justify-center bg-white/20 rounded-xl shrink-0">
                <i className="ri-question-line text-white text-2xl"></i>
              </div>
              <div className="flex-1">
                <p className="font-bold text-base">Not sure if we cover your area?</p>
                <p className="text-green-100 text-sm mt-0.5">Give us a call or send a message — we&apos;re happy to help.</p>
              </div>
              <a
                href="tel:6479837924"
                className="whitespace-nowrap bg-white text-green-700 font-semibold text-sm px-5 py-2.5 rounded-xl hover:bg-green-50 transition-colors cursor-pointer"
              >
                Call Us
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
